/* eslint-disable jsx-a11y/anchor-is-valid */
import {useFormik} from 'formik'
import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {isEmpty, isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {scrollToFieldError} from '../../../../utils/view'
import {useListView} from '../core/ListViewProvider'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {useLocation} from 'react-router-dom'
import {useAuth, MenuModel, getMenuAccess} from '../../../auth'
import {createJudi, rejectJudi, updateJudi, verifyJudi} from '../core/_requests'
import clsx from 'clsx'
import DatePicker from '../../../../components/DatePicker'
import ItemUnitsSelect from '../../../itemUnits/components/ItemUnitsSelect'
import EvidenceSelect from '../../../evidence/components/EvidenceSelect'
import {JudiListLoading} from '../components/loading/JudiListLoading'
import {initialJudi, Judi} from '../core/_models'
import {
  initialReporter,
  Reported,
  Reporter,
  ReportEvidence,
  Suspect,
} from '../../../judol/judol-list/core/_models'
import {ItemUnit} from '../../../itemUnits/core/_model'
import CaseStatusSelect from '../../../case-status/components/CaseStatusSelect'
import {ReportAmplificationForm} from '../../../amplification/components/ReportAmplificationForm'
import {ModusOperandiSelect} from '../../../modus-operandi/components/ModusOperandiSelect'
import {Accordion} from 'react-bootstrap'
import moment from 'moment'
import ReportReported from '../../../../components/ReportReported'
import ReportSuspect from '../../../../components/ReportSuspect'
import ReportEvidenceForm from '../../../../components/ReportEvidence'
import SubSatgasEnum from '../../../../enums/SubSatgasEnum'
import {useMutation} from 'react-query'
import {Confirm} from '../../../../components/Confirm'
import {showError} from '../../../../utils/toast'

type props = {
  judi: Judi
  isLoading: boolean
}

let yupValidation = {
  // policeReportNo: Yup.string().required('Nomor laporan polisi wajib diisi'),
  // policeReportDate: Yup.string().required('Tanggal laporan polisi wajib diisi'),
  // reportDate: Yup.string().required('Tanggal laporan wajib diisi'),
  // crimeScene: Yup.string().required('Tempat kejadian wajib diisi'),
  // crimeTime: Yup.string().required('Waktu kejadian wajib diisi'),
  // caseStatusId: Yup.string().required('Status Kasus wajib diisi'),
  // chronology: Yup.string().required('Kronologi wajib diisi'),
  // attentionDesc: Yup.string().max(1024, 'Maksimal 1024 karakter').notRequired(),
}

const addJudolSchema = Yup.object().shape({
  ...yupValidation,
})
const editJudolSchema = Yup.object().shape({
  ...yupValidation,
})

const JudiEditModalForm: FC<props> = ({judi, isLoading}) => {
  const {setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const {pathname} = useLocation()
  const {currentMenu} = useAuth()
  const [menuAccess, setMenuAccess] = useState<MenuModel | undefined>(undefined)

  const [showVerifyConfirmation, setShowVerifyConfirmation] = useState(false)
  const [showRejectConfirmation, setShowRejectConfirmation] = useState(false)
  const [isVerify, setIsVerify] = useState(false)
  const [isReject, setIsReject] = useState(false)

  const [reporterForm, setReporterForm] = useState<Reporter>({...initialReporter})

  const [reported, setReported] = useState<Reported[]>([])
  const [isEditReported, setEditReported] = useState<boolean>(false)

  const [suspects, setSuspect] = useState<Suspect[]>([])
  const [suspectForm, setSuspectForm] = useState<Suspect>({})
  const [isEditSuspect, setEditSuspect] = useState<boolean>(false)

  const [evidences, setEvidences] = useState<ReportEvidence[]>([])
  const [evidenceForm, setEvidenceForm] = useState<ReportEvidence>({})
  const [isEditEvidence, setEditEvidence] = useState<boolean>(false)
  const [amplifications, setAmplifications] = useState<any[]>([])
  const [itemUnit, setItemUnit] = useState<ItemUnit | undefined>()
  const [isSubmit, setIsSubmit] = useState(true)
  const [tabActive, setTabActive] = useState(0)
  const [dynamicValidation, setDynamicValidation] = useState<any>(Yup.object().shape({}))
  const [isValidationUpdated, setIsValidationUpdated] = useState(false)
  const [tabs, setTabs] = useState([
    {
      id: '#report',
      label: 'Laporan',
      isRequired: true,
    },
    {
      id: '#detail',
      label: 'Detail',
      isRequired: false,
    },
    {
      id: '#evidence',
      label: 'Barang Bukti',
      isRequired: true,
    },
    {
      id: '#reporter',
      label: 'Data Pelapor',
      isRequired: false,
    },
    {
      id: '#suspect',
      label: 'Data Tersangka',
      isRequired: false,
    },
  ])
  const [isNext, setIsNext] = useState(true)

  const addNewSuspect = (item: Suspect) => {
    if (isEditSuspect) {
      const idx = suspects.findIndex((q) => q.key === item.key)

      if (idx >= 0) {
        setSuspect([...suspects.filter((_, i) => i !== idx), item])
        setEditSuspect(false)
      }
      return
    }

    setSuspect([...suspects, item])
  }

  const addNewReportEvidence = (item: ReportEvidence) => {
    if (isEditEvidence) {
      const idx = evidences.findIndex((q) => q.id === item.id)

      if (idx >= 0) {
        setEvidences([...evidences.filter((_, i) => i !== idx), item])
        setEditEvidence(false)
      }
      return
    }

    setEvidences([...evidences, item])
  }

  useEffect(() => {
    setMenuAccess(getMenuAccess(currentMenu ?? [], pathname))
  }, [currentMenu])

  const saveDraft = (_isNext = true) => {
    setIsNext(_isNext)
    setIsSubmit(false)
    setDynamicValidation(getValidation(false))
    setIsValidationUpdated(true)
    // formik.handleSubmit()
  }

  useEffect(() => {
    if (isValidationUpdated) {
      formik.handleSubmit()
      setIsValidationUpdated(false)
    }
  }, [isValidationUpdated])

  const [data, setData] = useState<Judi>({
    ...judi,
    id: judi.id || initialJudi.id,
    policeReportNo: judi.policeReportNo || initialJudi.policeReportNo,
    policeReportDate: judi.policeReportDate || initialJudi.policeReportDate,
    caseStatusId: judi.caseStatusId || initialJudi.caseStatusId,
    crimeScene: judi.crimeScene || initialJudi.crimeScene,
    crimeTime: judi.crimeTime || initialJudi.crimeTime,
    chronology: judi.chronology || initialJudi.chronology,
    caseStatusName: judi.caseStatusName || initialJudi.caseStatusName,
    attentionLevel: judi.attentionLevel || 1,
    suspectRequired: judi.suspectRequired || false,
    reportDate: judi.reportDate || moment().startOf('days').toDate().toISOString(),
  })

  useEffect(() => {
    if (!isLoading) {
      setData({
        ...judi,
        id: judi.id || initialJudi.id,
        policeReportNo: judi.policeReportNo || initialJudi.policeReportNo,
        policeReportDate: judi.policeReportDate || initialJudi.policeReportDate,
        caseStatusId: judi.caseStatusId || initialJudi.caseStatusId,
        crimeScene: judi.crimeScene || initialJudi.crimeScene,
        crimeTime: judi.crimeTime || initialJudi.crimeTime,
        chronology: judi.chronology || initialJudi.chronology,
        caseStatusName: judi.caseStatusName || initialJudi.caseStatusName,
        attentionLevel: judi.attentionLevel || 1,
        suspectRequired: judi.suspectRequired || false,
        reportDate: judi.reportDate || moment().startOf('days').toDate().toISOString(),
      })

      setSuspect(judi.suspects)
      setReported(judi.reporteds)
      setReporterForm({
        ...initialReporter,
        name: judi.reporters[0]?.name || initialReporter.name,
        nik: judi.reporters[0]?.nik || initialReporter.nik,
        address: judi.reporters[0]?.address || initialReporter.address,
        gender: judi.reporters[0]?.gender || initialReporter.gender,
        dob: judi.reporters[0]?.dob || initialReporter.dob,
        pob: judi.reporters[0]?.pob || initialReporter.pob,
      })
      setEvidences(judi.evidences)

      // if (!judi.reportDate) {
      //   formik.setFieldValue('reportDate', moment().format('yyyy-MM-DD'))
      // }

      if (judi.amplifications && judi.amplifications.length > 0) {
        setAmplifications(judi.amplifications)
      }
      updateRequiredTab(judi.suspectRequired ?? false)
    }
  }, [judi, isLoading])

  const updateRequiredTab = (val: boolean) => {
    setTabs((prev) =>
      prev.map((item, index) => (index === tabs.length - 1 ? {...item, isRequired: val} : item))
    )
  }

  const isSuspectRequired = () => {
    return tabs[3].isRequired
  }

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const getValidation = (isSubmit = true) => {
    let yupValidation = {}
    if (isSubmit) {
      yupValidation = {
        policeReportNo: Yup.string()
          .required('Nomor laporan polisi wajib diisi')
          .max(1024, 'Maksimal 1024 karakter'),
        policeReportDate: Yup.string().required('Tanggal laporan polisi wajib diisi'),
        reportDate: Yup.string().required('Tanggal laporan wajib diisi'),
        crimeScene: Yup.string()
          .required('Tempat kejadian wajib diisi')
          .max(2048, 'Maksimal 2048 karakter'),
        crimeTime: Yup.string().required('Waktu kejadian wajib diisi'),
        caseStatusId: Yup.string().required('Status Kasus wajib diisi'),
        chronology: Yup.string().max(4096, 'Maksimal 4096 karakter'),
        attentionDesc: Yup.string().max(2048, 'Maksimal 2048 karakter').notRequired(),
      }
    } else {
      yupValidation = {
        policeReportNo: Yup.string()
          .required('Nomor laporan polisi wajib diisi')
          .max(1024, 'Maksimal 1024 karakter'),
        reportDate: Yup.string().required('Tanggal laporan wajib diisi'),
        caseStatusId: Yup.string().required('Status Kasus wajib diisi'),
        crimeScene: Yup.string().max(2048, 'Maksimal 2048 karakter'),
        attentionDesc: Yup.string().max(2048, 'Maksimal 2048 karakter').notRequired(),
        chronology: Yup.string().max(4096, 'Maksimal 4096 karakter'),
      }
    }

    return Yup.object().shape({
      ...yupValidation,
    })
  }

  const formik = useFormik({
    initialValues: data,
    validationSchema: dynamicValidation,
    enableReinitialize: true,
    onSubmit: async (values, {setSubmitting, setStatus}) => {
      if (isSubmit) {
        if (evidences.length === 0) {
          showError('Barang bukti wajib diisi (minimal 1)')
          setTabActive(2)
          return
        }
        if (isSuspectRequired() && suspects.length === 0) {
          showError('Data tersangka wajib diisi (minimal 1)')
          setTabActive(4)
          return
        }
      }

      setStatus(null)
      setSubmitting(true)

      if (isVerify) {
        setIsVerify(false)
        await verifyJudi(judi.id)
        setSubmitting(false)
        cancel(true)
        return
      }

      if (isReject) {
        setIsReject(false)
        await rejectJudi(judi.id)
        setSubmitting(false)
        cancel(true)
        return
      }

      if (isNotEmpty(judi.id)) {
        values.evidences = evidences
        values.reporteds = reported

        if (!isEmpty(reporterForm)) {
          values.reporters = [reporterForm]
        }

        values.suspects = suspects
      }

      try {
        if (isNotEmpty(judi.id)) {
          values.isSubmit = isSubmit
          setIsSubmit(true)

          await updateJudi(values)
        } else {
          setIsSubmit(true)
          const result = await createJudi(values)
          if (result?.id) {
            setItemIdForUpdate(result.id)
            refetch()
          }
        }
        setSubmitting(false)
        if ((values.isSubmit || tabActive === tabs.length - 1) && isNext) {
          cancel(true)
        } else {
          setTabActive((prev) => prev + (isNext ? 1 : -1))
        }
      } catch (ex: any) {
        console.error(ex)
        showError(ex.message)
        // showError(ex.message)
      }
    },
  })

  useEffect(() => {
    if (!formik.isValid && formik.submitCount !== 0 && isValidationUpdated) {
      scrollToFieldError()
    }
  }, [formik.submitCount, formik.isValid, formik.errors, isValidationUpdated])

  const [isTerlaporTersangka, setIsTerlaporTersangka] = useState(false)

  const handleCheckboxChange = (e) => {
    setIsTerlaporTersangka(e.target.checked)
    if (e.target.checked) {
      setSuspect(reported)
    } else {
      setSuspect([])
    }
  }

  /* BEGIN:VERIFY */

  const handleCloseVerifyConfirmation = () => setShowVerifyConfirmation(false)
  const handleConfirmVerify = async () => {
    setIsVerify(true)
    handleCloseVerifyConfirmation()
    formik.handleSubmit()
  }

  const handleOpenVerifyConfirmation = () => {
    setShowVerifyConfirmation(true)
  }

  /* END:VERIFY */

  /* BEGIN:REJECT */

  const handleCloseRejectConfirmation = () => setShowRejectConfirmation(false)
  const handleConfirmReject = async () => {
    setIsReject(true)
    handleCloseRejectConfirmation()
    formik.handleSubmit()
  }

  const handleOpenRejectConfirmation = () => {
    setShowRejectConfirmation(true)
  }

  /* END:REJECT */

  // useEffect(() => {
  //   console.log('aa')

  //   const handleKeyDown = (event) => {
  //     console.log(event.key)

  //     if (event.key === 'Escape') {
  //       console.log('a')
  //       // cancel(false) // Call the close function
  //     }
  //   }

  //   window.addEventListener('keydown', handleKeyDown)

  //   // Cleanup the event listener when the modal is unmounted or closed
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown)
  //   }
  // }, [])

  return (
    <>
      <form
        className={clsx('p-3', {'readonly-form': judi.button?.allowEdit === false})}
        onSubmit={(e) => {
          e.preventDefault()
          setDynamicValidation(getValidation(true))
          setIsValidationUpdated(true)
        }}
      >
        <div className="form-tab-container">
          <ul className="nav nav-pills">
            {tabs.map((m, i) => {
              if (!isNotEmpty(judi.id) && i > 0) {
                return null
              }
              return (
                <li key={i} className="nav-item" onClick={() => setTabActive(i)}>
                  <a
                    className={`nav-link ${tabActive === i && 'active'}`}
                    aria-current="page"
                    href="#"
                  >
                    {m.label} {m.isRequired && <span className="text-danger">*</span>}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        {/*<fieldset disabled={!menuAccess?.canCreate || isLoading}>*/}
        <div>
          {formik.status ? (
            <div className="mb-lg-5 alert alert-danger">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          ) : (
            ''
          )}

          <div className="modal-tab-content tab-content">
              <div
                className={`tab-pane ${tabActive === 0 && 'fade show active'}`}
                id="report"
                role="tabpanel"
                aria-labelledby="report-tab"
              >
                <div className="tab-inner">
                  <div className="container-fluid">
                    <label className="form-section-title">
                      <i className="fa-regular fa-file-lines"></i> Data Laporan
                    </label>
                    <div className="row mb-3">
                      <div className="fv-row d-flex flex-column mb-7 col-6">
                        <label className="required mb-2">Tanggal Pelaporan</label>
                        <DatePicker
                          label="Select Date"
                          field={formik.getFieldProps('reportDate')}
                          form={formik}
                          labelFormat="d/m/Y"
                          {...formik.getFieldProps('reportDate')}
                          disabled={judi.button?.allowEdit === false}
                          isStatic={false}
                        />
                        {formik.touched.reportDate && formik.errors.reportDate && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              <span role="alert">{formik.errors.reportDate}</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="fv-row d-flex flex-column mb-7 col-6">
                        <label htmlFor="location" className="form-label required">
                          Status Kasus
                        </label>
                        <CaseStatusSelect
                          form={formik}
                          field={formik.getFieldProps('caseStatusId')}
                          disabled={judi.button?.allowEdit === false}
                          initialOptions={
                            judi && judi.caseStatusName
                              ? [
                                {
                                  value: judi.caseStatusId,
                                  label: judi.caseStatusName,
                                },
                              ]
                              : []
                          }
                          onChange={(e) => {
                            updateRequiredTab(e.suspectRequired ?? false)
                          }}
                        />
                        {formik.touched.caseStatusId && formik.errors.caseStatusId && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              <span role="alert">{formik.errors.caseStatusId}</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="reportNumber" className="form-label required">
                          Nomor Laporan Polisi
                        </label>
                        <input
                          placeholder="LP/XXX/XX/2024/..."
                          {...formik.getFieldProps('policeReportNo')}
                          type="text"
                          name="policeReportNo"
                          className={clsx(
                            'form-control mb-3 mb-lg-0',
                            {
                              'is-invalid':
                                formik.touched.policeReportNo && formik.errors.policeReportNo,
                            },
                            {
                              'is-valid':
                                formik.touched.policeReportNo && !formik.errors.policeReportNo,
                            },
                          )}
                          autoComplete="off"
                          disabled={
                            formik.isSubmitting || isLoading || judi.button?.allowEdit === false
                          }
                        />
                        {formik.touched.policeReportNo && formik.errors.policeReportNo && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              <span role="alert">{formik.errors.policeReportNo}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <div className="fv-row d-flex flex-column mb-7">
                          <label className="required mb-2">Tanggal Laporan Polisi</label>
                          <DatePicker
                            label="Select Date"
                            field={formik.getFieldProps('policeReportDate')}
                            form={formik}
                            {...formik.getFieldProps('policeReportDate')}
                            disabled={judi.button?.allowEdit === false}
                            isStatic={false}
                          />
                          {formik.touched.policeReportDate && formik.errors.policeReportDate && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                <span role="alert">{formik.errors.policeReportDate}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <label className="form-section-title">
                      <i className="fa-solid fa-location-dot"></i> Lokasi Kejadian
                    </label>
                    <div className="row mb-3">
                      <div className="mb-3 col-md-12">
                        <label htmlFor="location" className="form-label required">
                          Alamat Lengkap
                        </label>
                        <textarea
                          id="location"
                          className={clsx(
                            'form-control',
                            {
                              'is-invalid': formik.touched.crimeScene && formik.errors.crimeScene,
                            },
                            {
                              'is-valid': formik.touched.crimeScene && !formik.errors.crimeScene,
                            },
                          )}
                          rows={3}
                          placeholder="Masukkan alamat lengkap lokasi kejadian..."
                          {...formik.getFieldProps('crimeScene')}
                          disabled={judi.button?.allowEdit === false}
                        ></textarea>
                        {formik.touched.crimeScene && formik.errors.crimeScene && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              <span role="alert">{formik.errors.crimeScene}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <label className="form-section-title">
                      <i className="fa-regular fa-clock"></i> Waktu Kejadian
                    </label>

                    <div className="row mb-3">
                      <div className="fv-row mb-3 d-flex flex-column col-md-6">
                        <label className="required mb-2">Waktu Kejadian</label>
                        <DatePicker
                          label="Select Date"
                          field={formik.getFieldProps('crimeTime')}
                          {...formik.getFieldProps('crimeTime')}
                          form={formik}
                          enableTime={true}
                          labelFormat="d/m/Y H:i"
                          disabled={judi.button?.allowEdit === false}
                          isStatic={false}
                        />
                        {formik.touched.crimeTime && formik.errors.crimeTime && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              <span role="alert">{formik.errors.crimeTime}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <label className="form-section-title">
                      <i className="fa-solid fa-triangle-exclamation"></i> Atensi
                    </label>
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <div className="fv-row d-flex flex-column mb-7">
                          <label className="form-label required">Level</label>
                          <div className="form-check-inline mt-3">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                id="attentionLevel1"
                                value="1"
                                checked={formik.values.attentionLevel === 1}
                                onChange={(e) => formik.setFieldValue('attentionLevel', 1)}
                                disabled={judi.button?.allowEdit === false}
                              />
                              <label htmlFor="attentionLevel1">Biasa</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                id="attentionLevel2"
                                value="2"
                                checked={formik.values.attentionLevel === 2}
                                onChange={(e) => formik.setFieldValue('attentionLevel', 2)}
                                disabled={judi.button?.allowEdit === false}
                              />
                              <label htmlFor="attentionLevel2">Viral</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                id="attentionLevel3"
                                value="3"
                                checked={formik.values.attentionLevel === 3}
                                onChange={(e) => formik.setFieldValue('attentionLevel', 3)}
                                disabled={judi.button?.allowEdit === false}
                              />
                              <label htmlFor="attentionLevel3">Sangat Viral</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3 col-12">
                        <div className="fv-row d-flex flex-column mb-7">
                          <label className="form-label">Deskripsi</label>
                          <textarea
                            className={clsx(
                              'form-control',
                              {
                                'is-invalid': formik.touched.crimeScene && formik.errors.crimeScene,
                              },
                              {
                                'is-valid': formik.touched.crimeScene && !formik.errors.crimeScene,
                              },
                            )}
                            rows={3}
                            {...formik.getFieldProps('attentionDesc')}
                            disabled={judi.button?.allowEdit === false}
                          ></textarea>

                          {formik.touched.attentionDesc && formik.errors.attentionDesc && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                <span role="alert">{formik.errors.attentionDesc}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 1 && 'fade show active'}`}
                id="detail"
                role="tabpanel"
                aria-labelledby="report-detail"
              >
                <div className="tab-inner">
                  <div className="container-fluid">
                    <label className="form-section-title">
                      <i className="fa-regular fa-square-minus"></i> Modus Operandi
                    </label>
                    <div className="mb-3">
                      <label htmlFor="chronology" className="form-label">
                        Jenis Perjudian
                      </label>
                      <ModusOperandiSelect
                        isClearable={false}
                        isMulti={true}
                        initialOptions={
                          judi.modusOperandi && judi.modusOperandi.length > 0
                            ? judi.modusOperandi.map((e) => {
                              return {
                                value: e.modusOperandiId,
                                name: e.modusOperandiName,
                              }
                            })
                            : []
                        }
                        className="menu-outer-top"
                        form={formik}
                        disabled={!menuAccess?.canCreate || judi.button?.allowEdit === false}
                        field={formik.getFieldProps('modusOperandi')}
                        subSatgasId={SubSatgasEnum.GAKKUMJUKON}
                      />
                    </div>

                    <div className="row mb-3">
                      <div className="mb-3 col-md-12">
                        <label htmlFor="chronology" className="form-label">
                          Kronologi
                        </label>
                        <textarea
                          id="chronology"
                          className={clsx(
                            'form-control',
                            {
                              'is-invalid': formik.touched.chronology && formik.errors.chronology,
                            },
                            {
                              'is-valid': formik.touched.chronology && !formik.errors.chronology,
                            },
                          )}
                          rows={10}
                          placeholder="Detailkan kronologi"
                          {...formik.getFieldProps('chronology')}
                          disabled={judi.button?.allowEdit === false}
                        ></textarea>
                        {formik.touched.chronology && formik.errors.chronology && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              <span role="alert">{formik.errors.chronology}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 2 && 'fade show active'}`}
                id="evidence"
                role="tabpanel"
                aria-labelledby="report-evidence"
              >
                <div className="tab-inner">
                  <ReportEvidenceForm
                    useAccordion={false}
                    evidences={evidences}
                    isEditEvidence={isEditEvidence}
                    isLoading={isLoading}
                    setEditEvidence={setEditEvidence}
                    setEvidence={setEvidences}
                    disabled={judi.button?.allowEdit === false}
                    resetValidation={tabActive === 2}
                  />{' '}
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 3 && 'fade show active'}`}
                id="reporter"
                role="tabpanel"
                aria-labelledby="reporter-evidence"
              >
                <div className="tab-inner">
                  <div className="container-fluid">
                    <div className="row mb-2">
                      <input type="hidden" value={reporterForm.key} />
                      <div className="col-md-6 mb-3">
                        <label htmlFor="reporterName" className="form-label">
                          Nama
                        </label>
                        <input
                          name="reporterName"
                          type="text"
                          id="pelapor"
                          className="form-control"
                          placeholder="Masukkan nama pelapor"
                          value={reporterForm.name}
                          onChange={(e) => setReporterForm({...reporterForm, name: e.target.value})}
                          disabled={judi.button?.allowEdit === false}
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="reporterNik" className="form-label">
                          NIK
                        </label>
                        <input
                          name="reporterNik"
                          type="text"
                          className="form-control"
                          placeholder="NIK"
                          value={reporterForm.nik}
                          maxLength={16}
                          onChange={(e) => setReporterForm({...reporterForm, nik: e.target.value})}
                          disabled={judi.button?.allowEdit === false}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="reporterPob" className="form-label">
                          Tempat Lahir
                        </label>
                        <input
                          type="text"
                          name="reporterPob"
                          className="form-control"
                          placeholder="Masukkan tempat lahir"
                          value={reporterForm.pob}
                          onChange={(e) => setReporterForm({...reporterForm, pob: e.target.value})}
                          disabled={judi.button?.allowEdit === false}
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="fv-row d-flex flex-column mb-7">
                          <label className="mb-2" htmlFor="reporterDob">
                            Tanggal Lahir
                          </label>
                          <input
                            type="date"
                            name="reporterDob"
                            className="form-control"
                            value={reporterForm.dob}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, dob: e.target.value})
                            }
                            disabled={judi.button?.allowEdit === false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="mb-2" htmlFor="reporterAddress">
                          Alamat
                        </label>
                        <textarea
                          rows={1}
                          name="reporterAddress"
                          className="form-control"
                          value={reporterForm.address}
                          onChange={(e) =>
                            setReporterForm({...reporterForm, address: e.target.value})
                          }
                          disabled={judi.button?.allowEdit === false}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === tabs.length - 1 && 'fade show active'}`}
                id="suspect"
                role="tabpanel"
                aria-labelledby="suspect"
              >
                <div className="tab-inner">
                  <ReportSuspect
                    handleCheckboxChange={handleCheckboxChange}
                    isEditSuspect={isEditSuspect}
                    isLoading={isLoading}
                    isTerlaporTersangka={isTerlaporTersangka}
                    setEditSuspect={setEditSuspect}
                    setSuspect={setSuspect}
                    suspects={suspects}
                    disabled={judi.button?.allowEdit === false}
                    useAccordion={false}
                    useCheckbox={false}
                    resetValidation={tabActive === tabs.length - 1}
                  />
                </div>
              </div>
          </div>

          {isNotEmpty(judi.id) && (
            <>
            {/* <div className='mb-3'>
                  <label htmlFor='chronology' className='form-label required'>
                    Pasal
                  </label>
                  <CriminalOffenceSelect
                    isClearable={false}
                    isMulti={true}
                    initialOptions={[]}
                    className='menu-outer-top'
                    field={formik.getFieldProps('criminalOffences')}
                    form={formik}
                    disabled={!menuAccess?.canCreate}
                  />
                  {formik.touched.chronology && formik.errors.chronology && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.chronology}</span>
                      </div>
                    </div>
                  )}
                </div> */}

              {/* <Accordion className='mb-3'>
                  <Accordion.Item eventKey='0'>
                    <Accordion.Header>Data Pelapor</Accordion.Header>
                    <Accordion.Body>
                      <div className='row mb-2'>
                        <input type='hidden' value={reporterForm.key} />
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='reporterName' className='form-label'>
                            Nama
                          </label>
                          <input
                            name='reporterName'
                            type='text'
                            id='pelapor'
                            className='form-control'
                            placeholder='Masukkan nama pelapor'
                            value={reporterForm.name}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, name: e.target.value})
                            }
                            disabled={judi.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <label htmlFor='reporterNik' className='form-label'>
                            NIK
                          </label>
                          <input
                            name='reporterNik'
                            type='text'
                            className='form-control'
                            placeholder='NIK'
                            value={reporterForm.nik}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, nik: e.target.value})
                            }
                            disabled={judi.button?.allowEdit === false}
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='reporterPob' className='form-label'>
                            Tempat Lahir
                          </label>
                          <input
                            type='text'
                            name='reporterPob'
                            className='form-control'
                            placeholder='Masukkan tempat lahir'
                            value={reporterForm.pob}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, pob: e.target.value})
                            }
                            disabled={judi.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <div className='fv-row d-flex flex-column mb-7'>
                            <label className='mb-2' htmlFor='reporterDob'>
                              Tanggal Lahir
                            </label>
                            <input
                              type='date'
                              name='reporterDob'
                              className='form-control'
                              value={reporterForm.dob}
                              onChange={(e) =>
                                setReporterForm({...reporterForm, dob: e.target.value})
                              }
                              disabled={judi.button?.allowEdit === false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <label className='mb-2' htmlFor='reporterAddress'>
                            Alamat
                          </label>
                          <textarea
                            rows={1}
                            name='reporterAddress'
                            className='form-control'
                            value={reporterForm.address}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, address: e.target.value})
                            }
                            disabled={judi.button?.allowEdit === false}
                          ></textarea>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion> */}

              {/* <ReportReported
                  isEditReported={isEditReported}
                  isLoading={isLoading}
                  reported={reported}
                  setEditReported={setEditReported}
                  setReported={setReported}
                /> */}

              {/* <ReportSuspect
                  handleCheckboxChange={handleCheckboxChange}
                  isEditSuspect={isEditSuspect}
                  isLoading={isLoading}
                  isTerlaporTersangka={isTerlaporTersangka}
                  setEditSuspect={setEditSuspect}
                  setSuspect={setSuspect}
                  suspects={suspects}
                  disabled={judi.button?.allowEdit === false}
                />

                <ReportEvidenceForm
                  evidences={evidences}
                  isEditEvidence={isEditEvidence}
                  isLoading={isLoading}
                  setEditEvidence={setEditEvidence}
                  setEvidence={setEvidences}
                  disabled={judi.button?.allowEdit === false}
                /> */}

              {/*<>*/}
              {/*  <ReportAmplificationForm*/}
              {/*    reportId={judi.reportId ?? 0}*/}
              {/*    amplifications={amplifications}*/}
              {/*    setAmplifications={setAmplifications}*/}
              {/*    isLoading={isLoading}*/}
              {/*    disabled={judi.button?.allowEdit === false}*/}
              {/*  ></ReportAmplificationForm>*/}
              {/*</>*/}
            </>
          )}
        </div>

        {/* Submit Button */}
          <div className="mt-2 pt-3 border-top">
            {(judi.button?.allowSubmit === true || !isNotEmpty(judi.id)) && (
              <div className="d-flex justify-content-between">
                {tabActive > 0 && tabActive < tabs.length ? (
                  <button
                    type="button"
                    onClick={() => saveDraft(false)}
                    className="btn btn-secondary btn-active-light-primary me-3"
                  >
                    Kembali
                  </button>
                ) : (
                  <div></div>
                )}
                <div>
                  <button
                    type="button"
                    onClick={() => saveDraft(true)}
                    className="btn btn-outline btn-outline-primary btn-active-light-primary"
                  >
                    {tabActive === tabs.length - 1 ? 'Simpan' : 'Lanjutkan'}
                  </button>

                  {isNotEmpty(judi.id) && (
                    <button type="submit" className="btn btn-primary ms-3">
                      Submit Laporan
                    </button>
                  )}
                </div>
              </div>
            )}

            {judi.button?.allowReject && (
              <div className="col-md-6">
                <button
                  type="button"
                  className="btn btn-outline btn-outline-danger btn-danger w-100"
                  onClick={handleOpenRejectConfirmation}
                >
                  Tolak
                </button>
              </div>
            )}

            {judi.button?.allowVerif && (
              <div className="col-md-6">
                <button
                  type="button"
                  className="btn btn-success w-100"
                  onClick={handleOpenVerifyConfirmation}
                >
                  Verifikasi
                </button>
              </div>
            )}
          </div>
        {/*</fieldset>*/}
      </form>
      {(formik.isSubmitting || isLoading) && <JudiListLoading />}

      <Confirm
        show={showVerifyConfirmation}
        handleClose={handleCloseVerifyConfirmation}
        handleConfirm={handleConfirmVerify}
        name={`Verifikasi ${judi.policeReportNo}`}
        body={`Apakah anda yakin ingin memverifikasi ${judi.policeReportNo}?`}
        isLoading={formik.isSubmitting || isLoading}
      />
      <Confirm
        show={showRejectConfirmation}
        handleClose={handleCloseRejectConfirmation}
        handleConfirm={handleConfirmReject}
        name={`Tolak ${judi.policeReportNo}`}
        body={`Apakah anda yakin ingin menolak ${judi.policeReportNo}?`}
        isLoading={isLoading}
      />
    </>
  )
}

export {JudiEditModalForm}
